const KEY = 'trg.calendar.onlyCompany'

type StorageLike = Pick<Storage, 'getItem' | 'setItem'>

function browserStorage(): StorageLike | null {
  try {
    return typeof localStorage === 'undefined' ? null : localStorage
  } catch {
    return null
  }
}

/** Whether the person last chose to see only company events; off when nothing is stored or storage is blocked. */
export function readOnlyCompany(storage: StorageLike | null = browserStorage()): boolean {
  try {
    return storage?.getItem(KEY) === '1'
  } catch {
    return false
  }
}

export function storeOnlyCompany(on: boolean, storage: StorageLike | null = browserStorage()): void {
  try {
    storage?.setItem(KEY, on ? '1' : '0')
  } catch {
    // Storage blocked: the choice just does not outlive the page.
  }
}

export type CalendarScope = 'personal' | 'both' | 'company'

export const CALENDAR_SCOPES: readonly CalendarScope[] = ['personal', 'both', 'company']

/** Which segment the two stored flags amount to: only-company wins over show-company. */
export function scopeOf(onlyCompany: boolean, showCompany: boolean): CalendarScope {
  if (onlyCompany) return 'company'
  return showCompany ? 'both' : 'personal'
}

/** The two flags a segment sets; Company keeps company events on so leaving it lands on Both. */
export function scopeFlags(scope: CalendarScope): { onlyCompany: boolean; showCompany: boolean } {
  return { onlyCompany: scope === 'company', showCompany: scope !== 'personal' }
}

/** Show the segments where the company calendar is configured, or where a stored Company choice would otherwise strand the reader with no way back. */
export function scopeControlShown(companyOnly: boolean, companyConfigured: boolean, onlyCompany: boolean): boolean {
  return !companyOnly && (companyConfigured || onlyCompany)
}
